import { doc, getDoc, setDoc, Timestamp } from "firebase/firestore";
import { db } from "../firebase/index";
import Crypto from 'crypto-js';
import { v4 as uuidv4 } from 'uuid'

const sleep = (ms) => new Promise(resolve => setTimeout(resolve, ms));

async function getDocWithRetry(docRef, retries = 3, delayMs = 1500) {
  for (let attempt = 1; attempt <= retries; attempt++) {
    try {
      return await getDoc(docRef);
    } catch (err) {
      const isOffline = err.message && err.message.toLowerCase().includes('offline');
      if (isOffline && attempt < retries) {
        await sleep(delayMs * attempt);
      } else {
        throw err;
      }
    }
  }
}

class AuthService {
  async login(user) {
          
          let docSnap = {}
          let isAdmin  = false
          const settings = await getDocWithRetry(
            doc(db, "mystudent", "setting")
          );
          if (isNaN(user) === true) {
            if(settings.data().adminlist.find(c => c == user)){
              user = settings.data().studentid
              isAdmin = true;
            }else{
              return false;
            }
          }

          const log = doc(db, 'pelajar', user+"@student.uitm.edu.my");

          // Read BEFORE writing. Offline persistence applies a pending merge
          // write to the local cache straight away, so writing loggedAt first
          // materialises a local stub holding only that field. A read that
          // falls back to the cache then returns the stub -- exists() is true
          // but studentid, name and the rest of the profile are missing.
          docSnap = await getDocWithRetry(log);
          if (docSnap.exists()) {
            let data = docSnap.data()
            // Not every pelajar doc has an `email` field; the doc ID is the email.
            if (!data.email) data.email = docSnap.id

            // Crypto.AES.encrypt(undefined, key) does not throw: it encrypts an
            // empty message and returns a valid-looking ciphertext that decrypts
            // to "". Stored that way it silently corrupts the session, and the
            // guard in store/auth.modules.js logs the user out on the next page
            // load. Fail loudly here instead.
            if (!data.studentid) {
              throw new Error('Profil pelajar tidak lengkap (tiada studentid). Mohon log aduan ke https://units.uitm.edu.my');
            }

            if(isAdmin) data.hash = '#'
            let uuid = data.uuid;
            if(!uuid){
               uuid = uuidv4()
               await setDoc(log, {uuid: uuid}, { merge: true });
               data.uuid = uuid;
            }
            data.studentid = Crypto.AES.encrypt(docSnap.data().studentid, uuid).toString()
            localStorage.setItem('user', JSON.stringify(data));

            // Logged after the read so the write can never shadow the profile.
            setDoc(log, {loggedAt: Timestamp.now()}, { merge: true });
          } else {
             alert("Profil pelajar tidak dijumpai. Mohon log aduan ke https://units.uitm.edu.my");
          }

        // A fresh data() call: the caller (and the Vuex store) needs the
        // plaintext studentid, while localStorage keeps the encrypted one.
        const profile = docSnap.data();
        return profile && { email: docSnap.id, ...profile };
  }

  logout() {
    // Clear the app's own localStorage, but never Firebase's. Firebase Auth
    // persists the session in IndexedDB and falls back to localStorage under
    // "firebase:" keys when IndexedDB is unavailable (Safari private mode,
    // in-app webviews). A blanket clear() destroys the sign-in itself there,
    // turning a recoverable "reload the profile" into a real logout.
    try {
      Object.keys(localStorage)
        .filter(k => !k.startsWith('firebase'))
        .forEach(k => localStorage.removeItem(k));
    } catch (e) {
      // Fallback in case enumeration is blocked; remove known keys
      localStorage.removeItem('user');
      localStorage.removeItem('access_token');
      localStorage.removeItem('refresh_token');
      localStorage.removeItem('id_token');
      localStorage.removeItem('user_info');
      localStorage.removeItem('mystudent-from');
    }

  }
}

export default new AuthService();